The `seek-token` received as part of the query string when the candidate arrived from SEEK.

If `seek-token` is not available (i.e. the candidate did not arrive from SEEK), this field can be omitted.
